import { Component, OnDestroy, signal, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BannersService } from '../services/banners.service';
import { Banner } from '../models/banner';

@Component({
  selector: 'app-banners-overlay',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './banners-overlay.component.html',
  styleUrls: ['./banners-overlay.component.scss']
})
export class BannersOverlayComponent implements OnDestroy {
  private bannersService = inject(BannersService);

  private currentBannerIndex = signal(0);
  isTransitioning = signal(false);

  activeBanners = this.bannersService.getBanners();
  currentBanner = computed(() => {
    const banners = this.activeBanners();
    const index = this.currentBannerIndex();
    return banners.length > 0 ? banners[index] : null;
  });

  private imageTimer?: ReturnType<typeof setTimeout>;

  ngOnDestroy(): void {
    this.clearTimers();
  }

  isVideoFormat(fileUrl: string): boolean {
    const extension = fileUrl.split('.').pop()?.toLowerCase();
    return extension === 'mp4' || extension === 'webm';
  }

  /** Когда видео закончилось */
  onVideoEnded(): void {
    this.nextBanner();
  }

  /** Когда видео загрузилось */
  onVideoLoad(event: Event): void {
    const video = event.target as HTMLVideoElement;
    video.muted = true;
    video.play().catch(err => {
      console.error('Failed to autoplay video:', err);
      setTimeout(() => this.nextBanner(), 1000);
    });
  }

  /** Когда картинка загрузилась */
  onImageLoad(): void {
    this.clearTimers();
    this.imageTimer = setTimeout(() => {
      this.nextBanner();
    }, 15000);
  }

  /** Если картинка/видео не загрузились */
  onError(): void {
    this.clearTimers();
    setTimeout(() => this.nextBanner(), 1000);
  }

  private nextBanner(): void {
    const banners = this.activeBanners();
    if (banners.length === 0) return;

    this.clearTimers();
    this.isTransitioning.set(true);

    setTimeout(() => {
      const currentIndex = this.currentBannerIndex();
      const nextIndex = (currentIndex + 1) % banners.length;
      this.currentBannerIndex.set(nextIndex);

      setTimeout(() => {
        this.isTransitioning.set(false);
      }, 300);
    }, 300);
  }

  private clearTimers(): void {
    if (this.imageTimer) {
      clearTimeout(this.imageTimer);
      this.imageTimer = undefined;
    }
  }
}
